// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

/**
 * CRA / Webpack environment variables
 * (must match .env and Vercel exactly)
 */
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  // eslint-disable-next-line no-console
  console.error(
    "[supabaseClient] Missing env vars. Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_KEY",
  );
}

/**
 * Supabase client (single instance)
 */
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

/**
 * ---- Auth recovery helpers ----
 * (replaces manual localStorage clearing)
 */
export function clearSupabaseAuthStorage() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("sb-"))
      .forEach((k) => localStorage.removeItem(k));
  } catch (e) {
    console.warn("[auth] Failed clearing sb-* keys:", e);
  }
}

export async function recoverSessionOnce() {
  try {
    const res = await supabase.auth.getSession();
    if (res?.data?.session) return res.data.session;

    const hasSbKeys =
      typeof localStorage !== "undefined" &&
      Object.keys(localStorage).some((k) => k.startsWith("sb-"));

    if (!hasSbKeys) return null;

    clearSupabaseAuthStorage();
    const res2 = await supabase.auth.getSession();
    return res2?.data?.session || null;
  } catch (e) {
    console.warn("[auth] recoverSessionOnce error:", e);
    clearSupabaseAuthStorage();
    return null;
  }
}

/**
 * ---- TEMP DEBUG (optional, remove later) ----
 */
if (typeof window !== "undefined") {
  window.supabase = supabase;
}
